import { render } from "./ChangeColorsPanel.vue?vue&type=template&id=4845a058"
import script from "./ChangeColorsPanel.vue?vue&type=script&lang=js"
export * from "./ChangeColorsPanel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__